import { useTranslation } from 'react-i18next';

import { intercom } from '../../services/intercom';
import Button from '../buttons/Button';

import classes from './ErrorBoundary.module.scss';

export function ErrorMessage() {
  const { t } = useTranslation();
  return (
    <div className={classes.errorBoundaryWrapper}>
      <p className={classes.errorTitle}>{t('errors.oopsTitle')}</p>
      <p className={classes.errorText}>
        {t('errors.apologizeInconvenience')}
        <br />
        {t('errors.teamNotified')}
      </p>
      <p className={classes.errorText}>{t('errors.thankYouPatience')}</p>
      <div className={classes.buttonContainer}>
        <Button btnType="main" onClick={() => window.location.reload()}>
          {t('common.buttons.refreshPage')}
        </Button>
        <Button btnType="light" onClick={() => intercom.handleOpenSupport()}>
          {t('common.contactSupportUpperCase')}
        </Button>
      </div>
    </div>
  );
}
